export default {"src":"/_next/static/media/undraw_reading.4fbe800c.svg","height":734,"width":1020,"blurWidth":0,"blurHeight":0};